
import { useStore } from "@/store";
import { NLayout, NLayoutSider } from "naive-ui";
import { computed, defineComponent } from "vue";
import AddDiaryButton from "./components/AddDiaryButton.vue";
import ContentEditor from "./components/ContentEditor.vue";
import DiaryRecords from "./components/DiaryRecords.vue";
import SQFView from "./components/SQFView.vue";

export default defineComponent({
	components: {
		DiaryRecords,
		ContentEditor,
		SQFView,
		AddDiaryButton,
		NLayout,
		NLayoutSider,
	},
	setup: () => {
		const store = useStore();

		return {
			// Computed
			isCurrentDiary: computed(() => store.getters.getCurrentDiary?.key),
			unsaved: computed(() => store.getters.getUnsaved),
		};
	},
});
